import { extractValue, findSelectOption } from "../../../../../libs/utils";
import type { PlanFieldItem } from "./year-card/YearCard";
import { rentTypeOptions } from "../AddPlanComm";

/** Tracks which lease (TOR) type Step 3 payment plans were configured for. */
export const PAYMENT_PLAN_TOR_TYPE_KEY = "paymentPlanTorType";

export function shouldResetPaymentPlansForTorTypeChange(
  paymentPlanTorType: string | undefined | null,
  currentTorType: string | undefined,
): boolean {
  if (paymentPlanTorType == null || currentTorType == null) return false;
  return paymentPlanTorType !== currentTorType;
}

export function getClearedCommercialPaymentPlanBookingFormPatch() {
  return {
    commercialPaymentPlan: [] as [],
    paymentPlan: [] as [],
  };
}

export function mapFormPlansToCommercialPaymentPlan(plans: PlanFieldItem[]) {
  return plans.map((item, index) => ({
    ...item,
    noOfYear: item?.noOfYear ?? index + 1,
    installments: extractValue(item?.installments),
    rentType: extractValue(item?.rentType),
    torPeriod: extractValue(item?.torPeriod),
  }));
}

export function createEmptyCommercialPlanField(isTurnoverRentOnly: boolean) {
  if (!isTurnoverRentOnly) return {};

  return {
    rentType: findSelectOption(rentTypeOptions, "fixed"),
    annualRent: 0,
    installments: null,
    billingScheduleRows: undefined,
    serviceCharge: undefined,
    serviceChargeSchedule: undefined,
  };
}
